var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("default"),_c('c-help-icon',{attrs:{"text":_vm.$t('alarm.tooltips.priority'),"icon-class":"priority-help-icon ml-1","size":"16","top":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }